import { render, staticRenderFns } from "./PropertyManage.vue?vue&type=template&id=99ef33ea&scoped=true"
import script from "./PropertyManage.vue?vue&type=script&lang=js"
export * from "./PropertyManage.vue?vue&type=script&lang=js"
import style0 from "./PropertyManage.vue?vue&type=style&index=0&id=99ef33ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ef33ea",
  null
  
)

export default component.exports